/**
 * Route for `anomaly-alerts-ml-driven-unusual-activity-patterns`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AnomalyAlertsMlDrivenUnusualActivityPatternsPage } from "../features/anomaly-alerts-ml-driven-unusual-activity-patterns/AnomalyAlertsMlDrivenUnusualActivityPatternsPage";

export const anomalyAlertsMlDrivenUnusualActivityPatternsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/anomaly-alerts-ml-driven-unusual-activity-patterns",
	component: AnomalyAlertsMlDrivenUnusualActivityPatternsPage,
});

export default anomalyAlertsMlDrivenUnusualActivityPatternsRoute;
